import ClearButton from '@feature/ClearButton'
import GridContainer from '@feature/GridContainer'
import GridItem from '@feature/GridItem'
import Product from '@feature/Product'
import ResultsGrid from '@feature/ResultsGrid'
import SearchForm from '@feature/SearchForm'
import Space from '@feature/Space'
import TaxonomyButtons from '@feature/TaxonomyButtons'
import Taxonomy from '@feature/TaxonomyCollapse'
import { Box, Divider, Stack, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { selectQueriedTerm, selectSearchQuery, selectTaxonomies } from 'app/selectors'
import { clearFilters, termNavClicked } from 'app/thunks'
import React, { useState } from 'react'
import { TermId } from 'types'

const Search = () => {
  const queriedTerm = useAppSelector(selectQueriedTerm)
  const searchQuery = useAppSelector(selectSearchQuery)
  const [dispatchedQueriedTerm, setDispatchedQueriedTerm] = useState<TermId>()

  const dispatch = useAppDispatch()

  const tx = useAppSelector(selectTaxonomies)

  const countryTx = tx.find((f) => f.taxonomyId === 'COUNTRY')
  const categoryTx = tx.find((f) => f.taxonomyId === 'PRODUCTCATEGORY')
  const producerCountryTx = tx.find((f) => f.taxonomyId === 'PRODUCINGCOUNTRY')
  const stockistTx = tx.find((f) => f.taxonomyId === 'STOCKIST')
  const brandTx = tx.find((f) => f.taxonomyId === 'BRAND')
  const organicTx = tx.find((f) => f.taxonomyId === 'ORGANIC')

  /**
   * This all became a bit spaghetti
   */
  React.useEffect(() => {
    if (queriedTerm && queriedTerm.id !== dispatchedQueriedTerm) {
      // Checks if a term has been queried via the URI, and dispatch an action accordingly
      setDispatchedQueriedTerm(queriedTerm.id)
      dispatch(
        termNavClicked({
          taxonomyId: queriedTerm.taxonomyId,
          termId: queriedTerm.id,
          reset: false,
        })
      )
    } else if (!queriedTerm && dispatchedQueriedTerm) {
      // Otherwise, clear the filters and reset the state.
      setDispatchedQueriedTerm(undefined)
      dispatch(clearFilters())
    }
  }, [dispatch, queriedTerm, dispatchedQueriedTerm])

  return (
    <>
      <GridContainer flexShrink={0} justifyContent={'space-between'} alignItems={'flex-end'}>
        {/* Just a spacer */}
        <GridItem xs={12} sm={2} />

        {/* Country Selector */}
        <GridItem xs={12} sm={6}>
          {countryTx && <TaxonomyButtons taxonomy={countryTx} />}
        </GridItem>

        {/* Search Form */}
        <GridItem xs={12} sm={4}>
          <SearchForm />
        </GridItem>
      </GridContainer>

      <Space />

      {/* Main */}
      <GridContainer flexShrink={1} flexBasis="100%" flexGrow="0" overflow="hidden">
        {/* Filters Column */}
        <GridItem xs={12} sm={5} md={3} overflow="hidden" height="100%">
          <Stack spacing={1} height="100%">
            <Box padding={1} bgcolor={'secondary.main'}>
              <Typography variant="large">{'Filters'}</Typography>
            </Box>

            <Box>
              <ClearButton />
            </Box>

            {categoryTx && (
              <>
                <Divider />
                <Taxonomy taxonomy={categoryTx} />
              </>
            )}

            {producerCountryTx && (
              <>
                <Divider />
                <Taxonomy taxonomy={producerCountryTx} />
              </>
            )}

            {stockistTx && (
              <>
                <Divider />
                <Taxonomy taxonomy={stockistTx} />
              </>
            )}

            {brandTx && (
              <>
                <Divider />
                <Taxonomy taxonomy={brandTx} />
              </>
            )}

            {organicTx && (
              <>
                <Divider />
                <Taxonomy taxonomy={organicTx} />
              </>
            )}

            <Divider />
          </Stack>
        </GridItem>

        {/* Results Column */}
        <GridItem xs={12} sm={7} md={9} height="100%">
          <ResultsGrid EntityComp={Product} />
        </GridItem>
      </GridContainer>
    </>
  )
}

export default Search
